import knowledgeBaseEdit from './edit.vue'
import knowledgeBaseList from './list.vue'
import knowledgeBaseInfo from './info.vue'
import * as knowledgeBaseClass from './knowledgeBaseClass'
import * as knowledgeBaseTag from './knowledgeBaseTag'
import * as comment from './comment'

let a = Object.assign({ knowledgeBaseEdit, knowledgeBaseList,knowledgeBaseInfo},knowledgeBaseClass,knowledgeBaseTag,comment)
export default a
